/* Celia Pons Studio · movimiento, portada y conversor de tallas */
(() => {
  document.documentElement.classList.add('cps-js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const parent = e.target.closest('.cps') || document;
      const sibs = [...parent.querySelectorAll('.rv')];
      e.target.style.transitionDelay = (Math.max(0, sibs.indexOf(e.target)) % 6) * 80 + 'ms';
      e.target.classList.add('in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  const heroes = new WeakSet();
  function initHero(root) {
    if (heroes.has(root)) return; heroes.add(root);
    const imgs = [...root.querySelectorAll('.slides img')];
    if (imgs.length < 2 || reduce || !matchMedia('(max-width: 700px)').matches) return;
    let i = 0, timer = null;
    const next = () => { imgs[i].classList.remove('on'); i = (i + 1) % imgs.length; imgs[i].classList.add('on'); };
    const start = () => { if (!timer) timer = setInterval(next, 6000); };
    const stop = () => { clearInterval(timer); timer = null; };
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  }

  const T = {
    es: { 34: 'XS', 36: 'S', 38: 'M', 40: 'L', 42: 'XL' },
    it: { 38: 'XS', 40: 'S', 42: 'M', 44: 'L', 46: 'XL' },
    de: { 32: 'XS', 34: 'S', 36: 'M', 38: 'L', 40: 'XL' }
  };
  const findNum = (sys, size) => Object.keys(T[sys]).find((n) => T[sys][n] === size);
  const tools = new WeakSet();
  function initTool(root) {
    if (tools.has(root)) return; tools.add(root);
    const sysBox = root.querySelector('[data-sys-box]');
    const numBox = root.querySelector('[data-num-box]');
    const ans = root.querySelector('[data-answer]');
    if (!sysBox || !numBox || !ans) return;
    const tTitle = ans.dataset.title || 'Pide la talla [talla]';
    const tText = ans.dataset.text || '';
    let sys = 'es', num = '38';
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const render = () => {
      numBox.innerHTML = Object.keys(T[sys]).map((n) => `<button type="button" data-n="${n}" aria-pressed="${n === num}">${n}</button>`).join('');
      const s = T[sys][num];
      if (!s) return;
      const title = tTitle.replace('[talla]', s);
      const text = tText.replace('[es]', findNum('es', s)).replace('[it]', findNum('it', s)).replace('[de]', findNum('de', s));
      ans.innerHTML = `<strong>${esc(title)}</strong>${esc(text)}`;
    };
    sysBox.addEventListener('click', (e) => {
      const b = e.target.closest('button'); if (!b) return;
      sys = b.dataset.sys; num = Object.keys(T[sys])[2];
      sysBox.querySelectorAll('button').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      render();
    });
    numBox.addEventListener('click', (e) => { const b = e.target.closest('button'); if (!b) return; num = b.dataset.n; render(); });
    render();
  }

  function init(scope = document) {
    scope.querySelectorAll('.cps .rv').forEach((el) => (io ? io.observe(el) : el.classList.add('in')));
    scope.querySelectorAll('.cps-hero').forEach(initHero);
    scope.querySelectorAll('[data-cps-sizetool]').forEach(initTool);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();